import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TableModule, TabsModule } from '@zipari/design-system';
import { DocumentCenterComponent } from './document-center.component';
import { SharedModule } from '../shared.module';

@NgModule({
  declarations: [DocumentCenterComponent],
  imports: [CommonModule, SharedModule, TableModule, TabsModule],
  exports: [DocumentCenterComponent],
})
export class DocumentCenterModule {}
